import React, {useEffect, useState} from 'react';
import {useAppSelector} from '../../../../redux/hooks';
import {Divider} from 'primereact/divider';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ColumnGroup} from 'primereact/columngroup';
import {Row} from 'primereact/row';

const TrunkStatisticsDetails = (props: any) => {
    const statisticTrunkData = useAppSelector(state => state.TrunkStatisticsListReducer.statisticTrunkData);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const pickCount = (obj: any, keys: string[]) => {
        for (const key of keys) {
            if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
        }
        return 0;
    };

    const pickDuration = (obj: any, keys: string[]) => {
        for (const key of keys) {
            if (obj?.[key] !== undefined && obj?.[key] !== null) return obj[key];
        }
        return null;
    };

    const pickString = (obj: any, keys: string[]) => {
        for (const key of keys) {
            if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== '') return obj[key];
        }
        return null;
    };

    const convertSecondsToTime = (totalSeconds: number | null | undefined): string => {
        if (totalSeconds === null || totalSeconds === undefined) return '---';
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const remainingSeconds = totalSeconds % 60;
        const seconds = remainingSeconds >= 0.5 ? Math.ceil(remainingSeconds) : Math.floor(remainingSeconds);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const phoneNumber =
        pickString(statisticTrunkData, ['aNumber', 'number', 'phoneNo', 'phone']) ?? '- - -';
    const rowId = statisticTrunkData?.trunkPhoneId ?? statisticTrunkData?.id;

    const summaryHeaderGroup = () => (
        <ColumnGroup>
            <Row>
                <Column header="Всього дзвінків" colSpan={2} />
                <Column header="Вхідні дзвінки" colSpan={2} />
                <Column header="Вихідні дзвінки" colSpan={2} />
            </Row>
            <Row>
                <Column header="Кількість" />
                <Column header="Тривалість" />
                <Column header="Кількість" />
                <Column header="Тривалість" />
                <Column header="Кількість" />
                <Column header="Тривалість" />
            </Row>
        </ColumnGroup>
    );

    const summaryRow = [
        {
            totalCount: pickCount(statisticTrunkData, ['allCalls', 'totalCallsCount', 'callsCount', 'totalCount']),
            totalDuration: pickDuration(statisticTrunkData, ['allDuration', 'totalCallsDuration', 'duration', 'totalDuration']),
            incomingCount: pickCount(statisticTrunkData, ['internalCount', 'incomingCallsCount', 'incomingCount']),
            incomingDuration: pickDuration(statisticTrunkData, ['internalFullduration', 'incomingCallsDuration', 'incomingDuration']),
            outgoingCount: pickCount(statisticTrunkData, ['externalCount', 'outgoingCallsCount', 'outgoingCount']),
            outgoingDuration: pickDuration(statisticTrunkData, ['externalFullduration', 'outgoingCallsDuration', 'outgoingDuration']),
        },
    ];

    const closeDetails = () => {
        props.setSelectedRowData(null);
        props.setSelectedRowExpansion?.(null);
    };

    return (
        <div className="relative">
            <div className="grid" style={{padding: '0.3rem 10px 5px'}}>
                {windowWidth > 1248 && (
                    <div className="grid col-12 md:col-12 mb-0 px-0 w-full justify-content-between">
                        <div className="absolute top-0 right-0 pr-2">
                            <button type="button" className="close-button block cursor-pointer ml-auto" onClick={closeDetails}>
                                <span className="pi pi-times" />
                            </button>
                        </div>
                        <div className="field col-12 md:col-10 flex align-items-start m-0 pb-3 pl-0">
                            <div className="field col-12 md:col-12 flex m-0 py-0 flex-column">
                                <div className="flex align-items-center pl-2 mb-2">
                                    <div className="mr-2 font-semibold">{phoneNumber}</div>
                                    {props.trunkName && (
                                        <span className="text-color-secondary ml-2">{props.trunkName}</span>
                                    )}
                                </div>
                                <div className="pl-2 text-sm">ID: {rowId ?? '- - -'}</div>
                            </div>
                        </div>
                        <Divider className="mt-0 ml-2 mb-1" />
                        <p className="pl-3 mt-2 mb-2">Статистика по номеру:</p>
                        <DataTable
                            className="col-12 md:col-12 py-0 statisticksDetailTable"
                            value={summaryRow}
                            headerColumnGroup={summaryHeaderGroup()}
                        >
                            <Column body={(row) => row.totalCount} style={{width: '16%'}} />
                            <Column body={(row) => convertSecondsToTime(row.totalDuration)} style={{width: '16%'}} />
                            <Column body={(row) => row.incomingCount} style={{width: '16%'}} />
                            <Column
                                body={(row) =>
                                    !row.incomingCount ? '---' : convertSecondsToTime(row.incomingDuration)
                                }
                                style={{width: '16%'}}
                            />
                            <Column body={(row) => row.outgoingCount} style={{width: '16%'}} />
                            <Column
                                body={(row) =>
                                    !row.outgoingCount ? '---' : convertSecondsToTime(row.outgoingDuration)
                                }
                                style={{width: '16%'}}
                            />
                        </DataTable>
                    </div>
                )}
                {windowWidth <= 1248 && (
                    <>
                        <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                            <p className="text-sm font-medium m-0">Номер</p>
                            <p className="text-sm m-0">{phoneNumber}</p>
                        </div>
                        {props.trunkName && (
                            <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                                <p className="text-sm font-medium m-0">Транк</p>
                                <p className="text-sm m-0">{props.trunkName}</p>
                            </div>
                        )}
                        <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                            <p className="text-sm font-medium m-0">ID</p>
                            <p className="text-sm m-0">{rowId ?? '- - -'}</p>
                        </div>
                        <Divider />
                        <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                            <p className="text-sm font-medium m-0">Всього (кількість / тривалість)</p>
                            <p className="text-sm m-0">
                                {pickCount(statisticTrunkData, ['allCalls', 'totalCallsCount', 'callsCount', 'totalCount'])} /{' '}
                                {convertSecondsToTime(pickDuration(statisticTrunkData, ['allDuration', 'totalCallsDuration', 'duration', 'totalDuration']))}
                            </p>
                        </div>
                        <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                            <p className="text-sm font-medium m-0">Вхідні (кількість / тривалість)</p>
                            <p className="text-sm m-0">
                                {pickCount(statisticTrunkData, ['internalCount', 'incomingCallsCount', 'incomingCount'])} /{' '}
                                {!pickCount(statisticTrunkData, ['internalCount', 'incomingCallsCount', 'incomingCount'])
                                    ? '---'
                                    : convertSecondsToTime(pickDuration(statisticTrunkData, ['internalFullduration', 'incomingCallsDuration', 'incomingDuration']))}
                            </p>
                        </div>
                        <div className="field col-12 md:col-12 align-items-center m-0 py-1">
                            <p className="text-sm font-medium m-0">Вихідні (кількість / тривалість)</p>
                            <p className="text-sm m-0">
                                {pickCount(statisticTrunkData, ['externalCount', 'outgoingCallsCount', 'outgoingCount'])} /{' '}
                                {!pickCount(statisticTrunkData, ['externalCount', 'outgoingCallsCount', 'outgoingCount'])
                                    ? '---'
                                    : convertSecondsToTime(pickDuration(statisticTrunkData, ['externalFullduration', 'outgoingCallsDuration', 'outgoingDuration']))}
                            </p>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default TrunkStatisticsDetails;
